"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESPONSE_SERVER_ERROR = exports.RESPONSE_BAD_REQUEST = exports.setRequestInterceptor = exports.aiAnswersInteractionsInstance = exports.statsInstance = exports.apiInstance = void 0;
const axios_1 = __importDefault(require("axios"));
const apiInstance = axios_1.default.create();
exports.apiInstance = apiInstance;
const statsInstance = axios_1.default.create();
exports.statsInstance = statsInstance;
const aiAnswersInteractionsInstance = axios_1.default.create();
exports.aiAnswersInteractionsInstance = aiAnswersInteractionsInstance;
const RESPONSE_BAD_REQUEST = 400;
exports.RESPONSE_BAD_REQUEST = RESPONSE_BAD_REQUEST;
const RESPONSE_SERVER_ERROR = 500;
exports.RESPONSE_SERVER_ERROR = RESPONSE_SERVER_ERROR;
const setRequestInterceptor = (callback, requestType) => {
    const axiosInstance = requestType === 'searchApi' ? apiInstance : statsInstance;
    axiosInstance.interceptors.request.use((config) => {
        const updatedConfig = callback({
            url: config.url,
            headers: config.headers
        });
        config = Object.assign(Object.assign({}, config), updatedConfig);
        return config;
    }, (error) => {
        return Promise.reject(new Error(JSON.stringify(error)));
    });
};
exports.setRequestInterceptor = setRequestInterceptor;
//# sourceMappingURL=api.js.map